import {
  InlineResponse20013,
  InlineResponse20013FromJSON,
} from "../models/InlineResponse20013";
import * as runtime from "../runtime";
import { InlineResponse20017 } from '@/requests/mainApi/models/InlineResponse20017';

export class SystemApi extends runtime.BaseAPI {
  async getAgreementLinksRaw(): Promise<
    runtime.ApiResponse<InlineResponse20013>
  > {
    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-App-Version"] =
        this.configuration.apiKey("X-App-Version"); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Id"] =
        this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Type"] =
        this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Os-Version"] =
        this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
    }

    const response = await this.request({
      path: `/system/v1/system/links-agreement`,
      method: "GET",
      headers: headerParameters,
    });

    return new runtime.JSONApiResponse(response, ({ data }) => {
      return InlineResponse20013FromJSON(data);
    });
  }

  async getAgreementLinks(): Promise<InlineResponse20013> {
    const response = await this.getAgreementLinksRaw();

    return await response.value();
  }

  async getOrganizationRaw(): Promise<
    runtime.ApiResponse<InlineResponse20017>
  > {
    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-App-Version"] =
        this.configuration.apiKey("X-App-Version"); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Id"] =
        this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Type"] =
        this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Os-Version"] =
        this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
    }

    const response = await this.request({
      path: `/system/v1/system/organization`,
      method: "GET",
      headers: headerParameters,
    });

    return new runtime.JSONApiResponse(response, ({ data }) => {
      return data;
    });
  }

  async getOrganization(): Promise<InlineResponse20017> {
    const response = await this.getOrganizationRaw();

    return await response.value();
  }
}
